import { useEffect, useState } from 'react'
import ResponsiveLayout from 'containers/Layouts/ResponsiveLayout'
import { Paper, Tabs, Tab, Box, Grid, Typography } from '@material-ui/core'
import UpcomingExamTables from './StudentDashboard/UpcomingExamTable'
import OpenExamTable from './StudentDashboard/OpenExamTable'
import EndedExamTable from './StudentDashboard/EndedExamTable'
import ExamResultsTable from './StudentDashboard/ExamResultsTable'
import axiosConfig from 'utils/axiosConfig'

import './Examination.css'

const StudentDashboard = () => {
  const [selectedTab, setSelectedTab] = useState(0)
  const [upcomingExams, setUpcomingExams] = useState({})
  const [openExams, setOpenExams] = useState({})
  const [endedExams, setEndedExams] = useState({})
  const [submittedExams, setSubmittedExams] = useState([])

  const handleTabChange = (e, newValue) => {
    setSelectedTab(newValue)
  }

  const getExaminations = () => {
    axiosConfig.get(`/student-examinations`)
      .then((response) => {
        const responseData = response.data

        if (!responseData.success) {
          console.log(responseData.message)
          return
        }

        const examinations = responseData.examinations

        setUpcomingExams(examinations.upcoming)
        setOpenExams(examinations.open)
        setEndedExams(examinations.ended)
        setSubmittedExams(examinations.submitted)
      })
  }

  useEffect(() => {
    getExaminations()
  }, [])

  return (
    <ResponsiveLayout>
      <Grid lg={8} style={{margin: '0 auto'}}>
        <Box marginTop={3}>
          <Paper>
            <Box padding={3}>
              <Typography variant="h5" component="h1" className="mb-4">Your Examinations</Typography>
              <Tabs
                value={selectedTab}
                indicatorColor="primary"
                textColor="primary"
                onChange={handleTabChange}
                className="border-b-1 border-b-black mb-4"
              >
                <Tab label={`Open (${openExams.length ?? 0})`} />
                <Tab label={`Upcoming (${upcomingExams.length ?? 0})`} />
                <Tab label={`Ended (${endedExams.length ?? 0})`} />
                <Tab label={`Exam Results (${submittedExams.length ?? 0})`} />
              </Tabs>
              {selectedTab === 0 && <OpenExamTable examinations={openExams}/>}
              {selectedTab === 1 && <UpcomingExamTables examinations={upcomingExams} />}
              {selectedTab === 2 && <EndedExamTable examinations={endedExams} />}
              {selectedTab === 3 && <ExamResultsTable examinations={submittedExams} />}
            </Box>
          </Paper>
        </Box>
      </Grid>
    </ResponsiveLayout>
  )
}

export default StudentDashboard